import { useStrapiMedia } from '#imports'

/**
 * Prefixes a Strapi media path with the API base URL. Prefer this over calling `useStrapiMedia` directly
 * in `<script setup lang="ts">` templates, where auto-imports are not always typed correctly.
 */
export function strapiMedia(path: string | undefined): string {
  return path ? useStrapiMedia(path) : ''
}
